module.exports = __webpack_public_path__ + "img/logo-m2n.c8ed69ea.svg";